import { Box } from '@aicon-dev/caas-core';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FileViewer } from '../FileViewer';

import { UploadRenderProps } from './types';

export interface UplaodBasicProps extends UploadRenderProps {
  preview?: boolean;
}

export const UploadBasic = (props: UplaodBasicProps) => {
  const { fields, trigger, remove, preview } = props;
  const { t } = useTranslation('global');

  return (
    <>
      {trigger}

      <Ul>
        {fields.map((item) => (
          <Li key={item.id}>
            <FileItem>
              {item.status === 'uploading' ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        color: '#00000073',
                        fontSize: '14px',
                      }}
                      spin
                    />
                  }
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M17.4793 9.532L10.7911 16.2203C9.97179 17.0397 8.86052 17.5 7.70178 17.5C6.54305 17.5 5.43177 17.0397 4.61242 16.2203C3.79307 15.4009 3.33276 14.2896 3.33276 13.1309C3.33276 11.9721 3.79307 10.8608 4.61242 10.0414L11.3006 3.35312C11.8468 2.80688 12.5877 2.5 13.3602 2.5C14.1326 2.5 14.8735 2.80688 15.4197 3.35312C15.966 3.89937 16.2728 4.64024 16.2728 5.41275C16.2728 6.18526 15.966 6.92613 15.4197 7.47237L8.72429 14.1607C8.45118 14.4338 8.08075 14.5873 7.6945 14.5873C7.30826 14.5873 6.93783 14.4338 6.66472 14.1607C6.3916 13.8876 6.23816 13.5171 6.23816 13.1309C6.23816 12.7446 6.3916 12.3742 6.66472 12.1011L12.8434 5.92947"
                    stroke="#404040"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
              <FileName
                fileLinkExist={!!item.response?.url}
                href={item.response?.url}
                target="_blank"
              >
                {item.response?.filename ||
                  item.response?.name ||
                  item.file?.name ||
                  t('global:wrong_file')}
              </FileName>

              {item.status !== 'uploading' && (
                <DeleteButton onClick={() => remove(item)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.10754 17.8925L17.8927 6.10742M17.8927 17.8925L6.10754 6.10742"
                      stroke="#404040"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </DeleteButton>
              )}
            </FileItem>

            {preview && !!item.response?.url && item.status === 'done' && (
              <Box mt="8px" mx="-16px">
                <FileViewer files={item.response ? [item.response] : []} />
              </Box>
            )}
          </Li>
        ))}
      </Ul>
    </>
  );
};

const Ul = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Li = styled.li`
  margin-top: 8px;
`;

const FileItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px 0 12px;
  height: 40px;

  color: #00000073;
  font-size: 1rem;
  font-weight: 400;

  border-radius: 6px;
  background: #fafafa;

  /* transition: background-color 0.2s ease; */
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const FileName = styled.a<{ fileLinkExist: boolean }>`
  flex: 1;
  padding: 0 8px;
  color: rgba(0 0 0 / 50%);
  text-decoration: none;
  transition: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ fileLinkExist }) =>
    !!fileLinkExist &&
    `
    cursor: pointer;
    color: #505050;
  `}
`;

const DeleteButton = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0;

  border-radius: 2px;
  border: none;
  outline: none;
  background: none;

  /* transition: background-color 0.2s ease; */

  &:hover {
    color: rgba(0, 0, 0, 0.8);
    background-color: rgba(0, 0, 0, 0.1);
  }
`;
